export default __webpack_public_path__ + "static/media/Video.ab047d5b.gif";